import { AttendanceFilterOptionValue, FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { SeoHeadingHandlerDefaultSorting } from '../SeoHeadingHandlerDefaultSort';

export default class AreaAttendanceOnline extends SeoHeadingHandlerDefaultSorting {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		const selectionCount = this.selectionTypeCount(filterSelectionState);

		return (
			(await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState)) &&
			this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState) ===
				AttendanceFilterOptionValue.ONLINE &&
			(await this.singleSelectionFor(FilterKey.AREA, filterSelectionState)) &&
			(selectionCount === 2 ||
				(selectionCount === 3 && this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState)))
		);
	}

	protected async selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const area = this.getFilterOptionNameBy(FilterKey.AREA, filterSelectionState);

		const countryName = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);
		const country = countryName !== '' ? `, ${countryName}` : ``;

		const seoInfo = `Study online at these universities in ${area}${country}`;

		return Promise.resolve(seoInfo);
	}
}
